import { useEffect } from 'react';
import { format2ms } from '../utils/date';

// Заполняет массивы значений на индикаторах данными
export const useFillIndicatorsArrays = (
    indicatorUpdate,
    pulse,
    setPulse,
    respiratory_rate,
    setRespiratory_rate,
    saturation,
    setSaturation,
    oxygen_flow,
    setOxygen_flow
) => {
    const CHARTS_TIME_LENGTH = 60; // 60 секунд
    let previousNow = Date.now();
    useEffect(() => {
        const CHARTS_TIME_LENGTH = 60; // секунды

        const addData = (newPoint, prevData, setData) => {
            if (newPoint?.value === undefined || newPoint?.timestamp === undefined) return;

            // newPoint.timestamp приходит в миллисекундах (format2ms)
            const newOriginalTs = newPoint.timestamp;

            // новая точка: relative timestamp 0s и свой originalTimestamp
            const newPointObj = {
                value: newPoint.value,
                timestamp: 0, // секунды
                originalTimestamp: newOriginalTs, // ms
            };

            // если нет предыдущих данных — просто ставим новую точку
            if (!Array.isArray(prevData) || prevData.length === 0) {
                setData([newPointObj]);
                return;
            }

            // Вспомогательная функция: получить originalTimestamp для точки.
            // Если его нет, попробуем восстановить по ближайшей точке, у которой есть originalTimestamp.
            const inferOriginalTimestamp = (point, reference) => {
                if (point.originalTimestamp) return point.originalTimestamp;
                // если есть относительный timestamp (в сек) и reference имеет originalTimestamp,
                // то original = reference.originalTimestamp + (point.timestamp - reference.timestamp) * 1000
                if (
                    typeof point.timestamp === 'number' &&
                    reference?.originalTimestamp &&
                    typeof reference.timestamp === 'number'
                ) {
                    return Math.round(
                        reference.originalTimestamp + (point.timestamp - reference.timestamp) * 1000
                    );
                }
                return undefined;
            };

            // Найдём первую точку в prevData, у которой есть originalTimestamp (если есть)
            const refIndex = prevData.findIndex((p) => !!p.originalTimestamp);
            const referencePoint = refIndex >= 0 ? prevData[refIndex] : null;

            // Пересчитываем относительные timestamps строго по originalTimestamp
            const shifted = prevData
                .map((p) => {
                    const orig = p.originalTimestamp ?? inferOriginalTimestamp(p, referencePoint);
                    if (!orig) return null; // не можем однозначно восстановить — пропускаем
                    const relSec = (orig - newOriginalTs) / 1000; // положительное — в будущем, отрицательное — в прошлом
                    return {
                        ...p,
                        originalTimestamp: orig,
                        timestamp: relSec,
                    };
                })
                // убираем null и оставляем только в пределах окна [-CHARTS_TIME_LENGTH, 0]
                .filter(Boolean)
                .filter((p) => p.timestamp >= -CHARTS_TIME_LENGTH && p.timestamp <= 0);

            // Итог: новая точка + пересчитанные предыдущие
            const newData = [newPointObj, ...shifted];

            setData(newData);
        };

        addData(
            { value: indicatorUpdate?.pulse, timestamp: format2ms(indicatorUpdate?.timestamp) },
            pulse,
            setPulse
        );
        addData(
            {
                value: indicatorUpdate?.respiratory_rate,
                timestamp: format2ms(indicatorUpdate?.timestamp),
            },
            respiratory_rate,
            setRespiratory_rate
        );
        addData(
            {
                value: indicatorUpdate?.saturation,
                timestamp: format2ms(indicatorUpdate?.timestamp),
            },
            saturation,
            setSaturation
        );
        addData(
            {
                value: indicatorUpdate?.oxygen_flow,
                timestamp: format2ms(indicatorUpdate?.timestamp),
            },
            oxygen_flow,
            setOxygen_flow
        );
    }, [indicatorUpdate]);
};

